import numbro from 'numbro'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Separator as Separator_ } from '@root/shared/ui-kit'

import type { SuggestedGasSettings } from '../../model'

type GasSettingsPopoverProps = {
  settings: SuggestedGasSettings.SuggestedSettings
}

export const GasSettingsPopoverMetrics: React.FC<GasSettingsPopoverProps> = ({
  settings,
}) => {
  const { t } = useTranslation()

  const formattedFee = numbro(settings.suggestedMaxFeePerGas).format({
    trimMantissa: true,
    mantissa: 4,
    thousandSeparated: true,
  })

  const formattedPriorityFee = numbro(
    settings.suggestedMaxPriorityFeePerGas,
  ).format({
    trimMantissa: true,
    mantissa: 4,
    thousandSeparated: true,
  })

  return (
    <Root>
      <Separator />
      <Row>
        <RowLabel>{t('gas-settings.max-fee')}:</RowLabel>
        <RowValue>{formattedFee} GWEI</RowValue>
      </Row>
      <Row>
        <RowLabel>{t('gas-settings.priority-fee')}:</RowLabel>
        <RowValue>{formattedPriorityFee} GWEI</RowValue>
      </Row>
    </Root>
  )
}

const Root = styled.div``

const Separator = styled(Separator_)`
  margin-inline: -12px;
  margin-block: 10px;
`

const Row = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 3px;
  align-items: center;
`

const RowLabel = styled.div`
  color: var(--text-12);
  font-size: 12px;
  font-weight: 500;
  line-height: 19px;
`

const RowValue = styled.div`
  color: var(--text-11);
  font-size: 12px;
  font-weight: 500;
  line-height: 19px;
`
